module.exports = __webpack_public_path__ + "static/FuturaStd-Book-366587622dea0883857f3a548c259dc5.woff2";